// extracted by mini-css-extract-plugin
export default {"postLoginLayout":"postLoginLayout_postLoginLayout__tD7mr","header":"postLoginLayout_header__ie5dq","content":"postLoginLayout_content__DPiw6"};